import {
  SHIP_TO_TEMPLATE_FILENAME,
  SHIP_TO_TEMPLATE_ROWS,
} from '../constants/voucher-target-form.constants';

export const parseNullableNumber = (
  value: string | number | null | undefined
) => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const downloadShipToTemplate = () => {
  const csvContent = SHIP_TO_TEMPLATE_ROWS.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = SHIP_TO_TEMPLATE_FILENAME;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(url);
};
